<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row >
     <legend class="subtitulos-simple"> Datos personales</legend>

      <b-col cols="6">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="person-circle"/>{{ }}
        <label style="font-size: 14px;">
          Nombre Completo:
        </label>
        <span> {{nombreCompleto}}  </span>
      </b-col>

      <b-col cols="4">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="gift"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Fecha de Nacimiento:
        </label>
        {{ fechaNacimiento | formatoFecha }}
      </b-col>

      <b-col cols="2">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="person-bounding-box"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Sexo:
        </label>
        {{ sexo }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="code-square"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Estado civil:
        </label>
        {{ estadoCivil }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="collection-fill"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Ocupación:
        </label>
        {{ ocupacion.toUpperCase() }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="collection-fill"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Tipo de seguridad electrónica (Tipo Empleado) :
        </label>
        {{ tipoEmpleado.toUpperCase() }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="at"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Email:
        </label>
        {{ correo }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="telephone-plus"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Teléfono de celular:
        </label>
        {{ telCelular }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="telephone-plus"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Teléfono de casa:
        </label>
        {{ telCasa }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="telephone-plus"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Teléfono de trabajo:
        </label>
        {{ telTrabajo }}
      </b-col>

    </b-row>

    <br/>
    <b-row>
      <legend class="subtitulos-simple"> Domicilio </legend>

      <b-col cols="6">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="house-door"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Calle
        </label>
        {{ calle }}
      </b-col>

      <b-col cols="3">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="arrow-up-short"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Número Exterior
        </label>
        {{ numeroExterior }}
      </b-col>

      <b-col cols="3">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="arrow-down-short"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Número Interior
        </label>
        {{ numeroInterior }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="asterisk"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Referencia
        </label>
        {{ referencia.toUpperCase() }}
      </b-col>

      <b-col cols="3">
        <b-icon style="color: #0e6ba9 " icon="badge-cc"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Código Postal
        </label>
        {{ cp }}
      </b-col>

      <b-col cols="3">
        <b-icon style="color: #0e6ba9 " icon="geo"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Estado
        </label>
        {{ estado.toUpperCase() }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="signpost-split"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Colonia
        </label>
        {{ colonia.toUpperCase() }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="geo"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Delegación/Municipio
        </label>
        {{ municipio.toUpperCase() }}
      </b-col>

    </b-row>

    <br/>
    <b-row>
      <legend class="subtitulos-simple"> Datos Escolares </legend>

      <b-col cols="6">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="award"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Cédula profesional:
        </label>
        {{ cedula }}
      </b-col>

      <b-col cols="6"  >
        <br/>
        <b-icon style="color: #0e6ba9 " icon="journal-medical"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Especialidades:
        </label>
        <span
            style="text-align: start;"
            v-for="(item, i) in especialidadStr"
            :key="i"
            :value="i">
          {{item.especialidad + ","}}
        </span>
      </b-col>

    </b-row>

    <br/>
    <b-row>
      <legend class="subtitulos-simple"> Datos Empleado </legend>

      <b-col cols="6">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="calendar2-check"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Fecha de ingreso:
        </label>
        {{ fechaAlta | formatoFecha }}
      </b-col>

      <b-col cols="3">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="hash"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Número empleado:
        </label>
        {{ numeroEmpleado }}
      </b-col>

      <b-col cols="3">
        <br/>
        <b-icon style="color: #0e6ba9 " icon="cash-coin"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Tipo de pago:
        </label>
        {{ tipoPago.toUpperCase() }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="arrow-bar-up"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Nivel:
        </label>
        {{ nivel }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="paperclip"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Esquema contratación:
        </label>
        {{ esquemaStr.toUpperCase() }}
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="person-lines-fill"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Jefe directo:
        </label>
        {{ jefeDirectoNombre.toUpperCase() }}
      </b-col>

      <b-col cols="3">
        <b-icon style="color: #0e6ba9 " icon="person-badge"/>{{ }}
        <label style="font-size: 14px; text-align:right">
         Medio tiempo:
        </label>
        <b-form-checkbox size="lg"
                         disabled
                         checked="tiempoCompleto"
                         v-model="tiempoCompleto"
                         style=" display: inline; margin: 5%; padding: 15%;"
        ></b-form-checkbox>
      </b-col>

      <b-col cols="3">
        <b-icon style="color: #0e6ba9 " icon="person-badge"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Asesor de confianza:
        </label>
        <b-form-checkbox size="lg"
                         disabled
                         checked="asesor"
                         v-model="asesor"
                         style=" display: inline; margin: 5%; padding: 10%;"
        ></b-form-checkbox>
      </b-col>

      <b-col cols="6">
        <b-icon style="color: #0e6ba9 " icon="building"/>{{ }}
        <label style="font-size: 14px; text-align:right">
          Clínicas:
        </label>
        <span
            style="text-align: start;"
            v-for="(item, i) in clinicaStr"
            :key="i"
            :value="i">
          {{item.nombreClinica + ","}}
        </span>


      </b-col>

    </b-row>

    <br/>
    <b-row>
      <legend class="subtitulos-simple"> Firma Empleado </legend>

    <b-col>
      <br/>
      <b-icon style="color: #0e6ba9 " icon="vector-pen"/>{{ }}
      <label style="font-size: 14px; text-align:right">
        Firma empleado:
      </label>
      <div v-if="firma == null ">
        <strong> El empleado aún no cuenta con una firma en NSD </strong>
        <b-icon icon="emoji-dizzy" animation="throb" style="color: #0e6ba9 " ></b-icon>

      </div>
      <div v-else class="container" >
        <img width="50%" class="contFirmaEmpleado"
             :src="'data:image/png;base64,'+ firma"
             alt="firma"
        />
      </div>
    </b-col>

    </b-row>



  </div>

</template>

<script>
export default {
  name: "InformacionEmpleado",
  props: {
    objetoColaboradorEntrada: Object,
  },

  data: () => ({
    loading: false,
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    nombreCompleto: null,
    fechaNacimiento: null,
    sexo: null,
    estadoCivil: null,
    ocupacion: null,
    tipoEmpleado: null,
    calle: null,
    numeroInterior: null,
    numeroExterior: null,
    referencia: null,
    cp: null,
    colonia: null,
    estado: null,
    municipio: null,
    correo: null,
    telCelular: null,
    telCasa: null,
    telTrabajo: null,
    cedula: null,
    fechaAlta: null,
    numeroEmpleado: null,
    tipoPago: null,
    nivel: null,
    esquemaStr: null,
    jefeDirectoNombre: null,
    tiempoCompleto: false,
    asesor: false,
    especialidadStr: [],
    clinicaStr: [],
    firma: null,


  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.crearObjetoColaborador();
  },
  methods: {
    crearObjetoColaborador() {
      this.loading = true;

        this.$http
            .get(
                this.$api +
                "colaboradores/obtenerInformacionColaboradorPorIdPersona?idPersona=" +
                this.objetoColaboradorEntrada.objetoColaborador.idPersona
            )
            .then((response) => {
              let datos = response.data.data;
              this.nombreCompleto = datos.nombre + " " + datos.materno + " " + datos.paterno
              this.fechaNacimiento = datos.fcNacimiento != null ? datos.fcNacimiento : " ";
              if (datos.sexo ==1){
                this.sexo = "MASCULINO"
              }else{
                this.sexo = "FEMENINO"
              }
              this.estadoCivil = datos.estadoCivilString != null ? datos.estadoCivilString : " ";
              this.ocupacion = datos.ocupacionStr != null ? datos.ocupacionStr : " ";
              this.tipoEmpleado = datos.tipoEmpleadoStr != null ? datos.tipoEmpleadoStr : " ";
              this.calle = datos.calle != null ? datos.calle : " ";
              this.numeroInterior = datos.noInterior != null ? datos.noInterior : " ";
              this.numeroExterior = datos.noExterior != null ? datos.noExterior : " ";
              this.referencia = datos.referencia != null ? datos.referencia : " ";
              this.cp = datos.codigoPostal != null ? datos.codigoPostal : " ";
              this.colonia = datos.colonia != null ? datos.colonia : " ";
              this.estado = datos.estado != null ? datos.estado : " ";
              this.municipio = datos.municipio != null ? datos.municipio : " ";
              this.correo = datos.correo != null ? datos.correo : " ";
              this.telCelular = datos.telCelular != null ? datos.telCelular : " ";
              this.telCasa = datos.telCasa != null ? datos.telCasa : " ";
              this.telTrabajo = datos.telTrabajo != null ? datos.telTrabajo : " ";
              this.cedula = datos.cedula != null ? datos.cedula : " ";
              this.fechaAlta = datos.fechaAlta != null ? datos.fechaAlta : " ";
              this.numeroEmpleado = datos.numeroEmpleado != null ? datos.numeroEmpleado : " ";
              this.tipoPago = datos.tipoPagoStr != null ? datos.tipoPagoStr : " ";
              this.nivel = datos.nivel != null ? datos.nivel : " ";
              this.esquemaStr = datos.esquemaStr != null ? datos.esquemaStr : " ";
              this.jefeDirectoNombre = datos.jefeDirectoNombre != null ? datos.jefeDirectoNombre : " ";
              this.tiempoCompleto = datos.tiempoCompleto != null ? datos.tiempoCompleto : " ";
              this.asesor = datos.asesorconfianza != null ? datos.asesorconfianza : " ";
              this.especialidadStr = datos.especialidadStr != null ? datos.especialidadStr : null;
              this.clinicaStr = datos.clinicaStr != null ? datos.clinicaStr : null;
              this.firma = datos.firma;



            })
            .catch((error) => {
              console.error(error);
            }).finally(() => {
                this.loading = false;

        });
          },
  }
}
</script>

<style scoped>


</style>